import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { timer } from 'rxjs';
import { Principal } from '../../shared/auth/principal.service';
import { LoginService } from '../../shared/auth/login/login.service';
import { AppSidebarService } from '../../shared/services/app-sidebar.service';
import { RolePermission } from '../../shared/auth/rbac/role-permission';
import { AdStatsPublishersService } from '../../shared/services/ad-stats-publishers.service';

@Component({
  selector: 'cm-main',
  templateUrl: './kn-main.component.html',
  styleUrls: ['./kn-main.component.scss']
})
export class KnMainComponent implements OnInit {

  @ViewChild(MatSidenav, { static: true }) sidenav: MatSidenav;

  showAdsTxtAlert = false;
  requestedPublishersCount = 0;
  screenWidth: number;
  mobileTopBar = document.getElementsByClassName('mobile-top-bar');
  scrollOffset: number;
  RolePermission = RolePermission;

  constructor(public principal: Principal,
    private service: AppSidebarService,
    private loginService: LoginService,
    private adStatsPublishersService: AdStatsPublishersService) {

    this.screenWidth = window.innerWidth;
  }


  ngOnInit(): void {
    this.service.sidebar$.subscribe(next => {
      this.sidenav.toggle(next);
    });

    timer(0, 60000).subscribe(() => this.checkForRequestedPublishers());
  }

  public logout() {
    this.loginService.logout(true);
  }

  @HostListener('window:resize')
  resizeScreen() {
    this.screenWidth = window.innerWidth;
  }

  @HostListener('window:scroll', ['$event']) onScrollEvent($event) {
    // console.log($event);
    if ($event.path && $event.path.length) {
      this.scrollOffset = $event.path[1].scrollY;
    } else {
      this.scrollOffset = 0;
    }
  }

  checkForRequestedPublishers() {
    this.adStatsPublishersService.publishersRequestsHasRequested().subscribe(next => {
      this.requestedPublishersCount = next;
    });
  }

}

